import React from "react";

// CSS
import "../../css/button.css";

class Button extends React.PureComponent {
	render() {
		return (
			<button
				className={
					`btn submit-btn` +
					(this.props.isLoading ? " loading" : "") +
					(this.props.classes ? " " + this.props.classes : "")
				}
				name="submit"
				value="submit"
				disabled={this.props.isDisabled ? this.props.isDisabled : this.props.isLoading}
				onClick={() => this.props.clickHandler()}
			>
				<span>{this.props.text}</span>
			</button>
		);
	}
}

export default Button;



// WEBPACK FOOTER //
// ./src/components/utils/Button.js